var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13V11H6.5V13H8.5Z",
    fill: "#1b5786"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11H9.5V13H11.5V11Z",
    fill: "#1b5786"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11H12.5V13H14.5V11Z",
    fill: "#1b5786"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13V11H17.5V13H15.5Z",
    fill: "#1b5786"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14H11.5V16H9.5V14Z",
    fill: "#1b5786"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16V14H6.5V16H8.5Z",
    fill: "#1b5786"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14H14.5V16H12.5V14Z",
    fill: "#1b5786"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16V14H15.5V16H17.5Z",
    fill: "#1b5786"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17H11.5V19H9.5V17Z",
    fill: "#1b5786"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19V17H6.5V19H8.5Z",
    fill: "#1b5786"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17H14.5V19H12.5V17Z",
    fill: "#1b5786"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19V17H15.5V19H17.5Z",
    fill: "#1b5786"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3C16.5 2.44772 16.9477 2 17.5 2C18.0523 2 18.5 2.44772 18.5 3V5H19C20.1046 5 21 5.89543 21 7V22.5H3V7C3 5.89543 3.89543 5 5 5H5.5V3C5.5 2.44772 5.94772 2 6.5 2C7.05228 2 7.5 2.44772 7.5 3V5H16.5V3ZM4.5 9H19.5V21H4.5V9Z",
    fill: "#1b5786"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c72175662404cbcdd411161a390c2c2e.svg";
export { ForwardRef as ReactComponent };